"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SessionClass = {
    getId: function () { return window.sessionStorage.getItem("sessionClassId"); },
    getSubjectId: function () { return window.sessionStorage.getItem("sessionSubjectId"); }
};
exports.default = SessionClass;
